<template>
  <div>
    <table v-if="data.length > 0" class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <tr class="bg-dark-grey-5 has-text-white has-text-centered tr-wrapper">
        <td class="py-4" style="width: 25%;">
          <p class="averta-bold">NAMA</p>
        </td>
        <td class="py-4" style="width: 25%;">
          <p class="averta-bold">NOMOR HP</p>
        </td>
        <td class="py-4" style="width: 25%;">
          <p class="averta-bold">ALAMAT EMAIL</p>
        </td>
        <td class="py-4" style="width: 15%;">
          <p class="averta-bold">STATUS</p>
        </td>
        <td class="py-4" style="width: 15%;"></td>
      </tr>
      <tr v-for="(item, index) in data" :key="index" class="vertical-middle tr-wrapper">
        <td class="py-3">
          <div class="is-flex is-align-items-center mx-2">
            <img
              v-if="item.image_url && item.image_url !== '-'"
              :src="item.image_url"
              class="image-pic mr-3 img-shadow-1"
            />
            <img
              v-else
              :src="require('@/assets/img/default-picture.jpg')"
              class="image-pic mr-3 img-shadow-1"
            />
            <p>{{ item.name }}</p>
          </div>
        </td>
        <td class="py-3">
          <p class="has-text-danger averta-bold">{{ item.phone }}</p>
        </td>
        <td class="py-3">
          <p>{{ item.email }}</p>
        </td>
        <td class="py-3 px-4">
          <div class="badge-status-table flex-center" :class="`${item.is_active === 1 ? 'active' : 'nonactive'}`">
            <p class="averta-bold color-white py-1">{{ item.is_active === 1 ? 'Aktif' : 'Tidak Aktif' }}</p>
          </div>
        </td>
        <td>
          <div class="flex-center">
            <div class="is-clickable mr-2 p-3" @click="handleOpenEditPIC(item)">
              <EditIcon color="#000" />
            </div>
            <!-- <div class="is-clickable" @click="handleDeletePIC(item)">
              <TrashIcon />
            </div> -->
          </div>
        </td>
      </tr>
    </table>

    <div v-else class="column c-w-100 has-text-centered">
      <ProyekEmptyIcon />
      <p class="averta-bold mt-2">
        Data Tidak Ditemukan
      </p>
    </div>

    <!-- Delete PIC -->
    <ModalConfirm
      :showModal="showModalDelete"
      imageProps="sunset.png"
      imageClass="mb-3"
      :titleProps="`Hapus ${titleDelete}?`"
      descProps="Pastikan kamu sudah lakukan pengecekkan sebelum menghapus data ini."
    >
      <template v-slot:button>
        <div class="is-flex">
          <ButtonApp @click="handleCancelDeletePIC" class="mr-3" :isSecondary="true" width="185px" height="52px">
            <p class="averta-bold px-4 py-1">Kembali</p>
          </ButtonApp>
          <ButtonApp @click="handleConfirmDeletePIC" width="185px" height="52px">
            <p class="averta-bold px-4 py-1">Hapus</p>
          </ButtonApp>
        </div>
      </template>
    </ModalConfirm>

    <SidebarEditPICBranch
      type="head"
      :show="showSidebar"
      :close="handleCloseSidebar"
      @updateTable="refreshData({refresh: true})"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { alertErrorMessage } from '@/helpers'
import { HEAD_ENGINEERING_SMRC } from '@/helpers/constants'
import { EditIcon, TrashIcon, ProyekEmptyIcon, SpinnerIcon } from '@/components/icons'

import ButtonApp from '@/components/button/ButtonApp.vue'
import ModalConfirm from '../ModalConfirm.vue'
import SidebarEditPICBranch from '../branch-components/SidebarEditPICBranch.vue'

export default {
  name: 'TabListHeadOfEngineering',
  props: {
    type: {
      type: String, // untuk 'admin'
      default: null
    },
    data: {
      type: Array
    },
    refreshData: {
      type: Function
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    TrashIcon,
    EditIcon,
    ProyekEmptyIcon,
    // eslint-disable-next-line vue/no-unused-components
    SpinnerIcon,

    ButtonApp,
    ModalConfirm,
    SidebarEditPICBranch
  },
  data () {
    return {
      showModalDelete: false,
      showModalEdit: false,
      itemDelete: null,
      showSidebar: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    }),
    isAdmin () {
      return this.type === 'admin'
    },
    titleDelete () {
      return HEAD_ENGINEERING_SMRC
    }
  },
  methods: {
    handleDeletePIC (item) {
      this.itemDelete = item
      this.showModalDelete = true
    },
    handleCancelDeletePIC () {
      this.itemDelete = null
      this.showModalDelete = false
    },
    handleConfirmDeletePIC () {
      this.showModalDelete = false

      const payload = {
        url: this.url,
        branch_id: this.$route.params.branchId,
        user_id: this.itemDelete.id
      }

      this.$store.dispatch('client/deleteAreaKoordinator', payload)
        .then(() => {
          this.$buefy.toast.open({
            message: 'PIC berhasil di hapus',
            type: 'is-success'
          })
          this.refreshData({ refresh: true })
        })
        .catch((error) => {
          alertErrorMessage(error)
        })
    },
    handleOpenEditPIC (data) {
      this.showSidebar = true
      this.$store.commit('client/setDetailPICBranch', data)
    },
    handleCloseSidebar () {
      this.showSidebar = false
      this.$store.commit('client/setClearPayloadStore')
    }
  }
}
</script>
